import React, { useState } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import Button from "../../features/Button";
import { Header } from "../../shared/compoments";
// import { MultiSelect } from 'primereact/multiselect';

function CouponsCreate() {
  const styleBtn = {
    padding: ".5em",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "black",
    backgroundColor: "rgb(255 177 47 / 99%)",
    marginTop: "1em",
    border: "none",
  };
  const MySwal = withReactContent(Swal);

  const [data, setData] = useState({ libelle: "" });
  const [isLoading, setIsLoading] = useState(false);
  const createRole = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      let dataSend = {
        libelle: data.libelle,
      };
      const response = await instance.post("roles", dataSend);

      console.log(response);
      if (response.data.status === false) {
        let msgError = [];
        for (const property in response.data.message) {
          msgError = [...msgError, response.data.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setData({ libelle: "" });
        MySwal.fire({
          title: "Enregistrement reussi.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Header libelle={"Enregistrer un role"} />
      <form onSubmit={createRole} className="px-3 my-3">
        <InputCreate
          label="libelle"
          typeInput="text"
          nameInput="libelle"
          active={true}
          getValue={(e) => {
            setData({ ...data, role: e.target.value });
          }}
          dataValue={data.role}
        />

        <div>
          <Button
            titre="Enregistrer"
            styleBtn={styleBtn}
            isLoading={isLoading}
          />
        </div>
      </form>
    </div>
  );
}

export default CouponsCreate;
